import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Referral() {
  const [referrals, setReferrals] = useState([]);
  const [myCode, setMyCode] = useState('');
  const [copied, setCopied] = useState(false);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetchReferrals();
  }, []);

  const fetchReferrals = async () => {
    try {
      const res = await fetch(API + '/referrals', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        const d = await res.json();
        setReferrals(d.referrals || []);
        if (d.referrals && d.referrals.length > 0) setMyCode(d.referrals[0].referral_code);
      }
    } catch (err) { console.error(err); }
  };

  const createCode = async () => {
    try {
      const res = await fetch(API + '/referrals', { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        const d = await res.json();
        setMyCode(d.referral.referral_code);
        fetchReferrals();
      }
    } catch (err) { console.error(err); }
  };

  const copyLink = () => {
    const link = `https://khepri.tech/?ref=${myCode}`;
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareTelegram = () => {
    window.open(`https://t.me/share/url?url=https://khepri.tech/?ref=${myCode}&text=Попробуй Khepri — ИИ-систему для бизнеса`, '_blank');
  };

  const shareVK = () => {
    window.open(`https://vk.com/share.php?url=https://khepri.tech/?ref=${myCode}`, '_blank');
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🎁 Реферальная программа</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Пригласите друга — получите <strong style={{ color: '#F7DE8A' }}>30 дней бесплатно</strong> к тарифу Autopilot.
      </p>

      <div style={{ padding: 20, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', marginBottom: 20 }}>
        <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>Ваш реферальный код</h3>
        {!myCode ? (
          <button onClick={createCode} style={{ padding: '12px 24px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>
            🎁 Создать код
          </button>
        ) : (
          <>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ padding: '12px 24px', background: '#0F172A', border: '2px dashed #F7DE8A', borderRadius: 8, fontSize: 20, fontWeight: 700, color: '#F7DE8A', letterSpacing: 2 }}>
                {myCode}
              </div>
              <button onClick={copyLink} style={{ padding: '12px 20px', background: '#8A6636', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                {copied ? '✅ Скопировано' : '📋 Копировать ссылку'}
              </button>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button onClick={shareTelegram} style={{ padding: '10px 20px', background: '#0088cc', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>📨 Telegram</button>
              <button onClick={shareVK} style={{ padding: '10px 20px', background: '#4C75A3', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>📘 ВКонтакте</button>
            </div>
          </>
        )}
      </div>

      <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📊 Статистика</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 20 }}>
        <div style={statCard}><div style={statLabel}>Приглашено</div><div style={statValue}>{referrals.length}</div></div>
        <div style={statCard}><div style={statLabel}>Зарегистрировались</div><div style={{...statValue, color: '#10B981'}}>{referrals.filter(r => r.status === 'registered').length}</div></div>
        <div style={statCard}><div style={statLabel}>Бонусных дней</div><div style={{...statValue, color: '#F7DE8A'}}>{referrals.reduce((s, r) => s + (r.bonus_days || 0), 0)}</div></div>
      </div>

      {referrals.length > 0 && (
        <>
          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📋 История приглашений</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {referrals.map((r, i) => (
              <div key={i} style={{ padding: 12, background: '#1E293B', borderRadius: 8, border: '1px solid #8A6636', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                <div>
                  <div style={{ color: '#F7DE8A', fontWeight: 600 }}>{r.referred_email || 'Приглашённый'}</div>
                  <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>{r.status}</div>
                </div>
                <span style={{ color: '#10B981', fontWeight: 700 }}>+{r.bonus_days} дн.</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

const statCard = { background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #8A6636', textAlign: 'center' };
const statLabel = { fontSize: 11, color: '#94A3B8', marginBottom: 6 };
const statValue = { fontSize: 24, fontWeight: 700, color: '#F8FAFC' };

export default Referral;